import * as React from "react"
import OutlinedInput from "@mui/material/OutlinedInput"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import ListItemText from "@mui/material/ListItemText"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import Checkbox from "@mui/material/Checkbox"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { iterateStringEnum } from "../../../../../../lib/enums"
import { ShopType } from "../merchantSalesTypes"
import { MenuProps } from "../../../../../../shared/components/filters/constants/filterMenuConst"

const useStyles = makeStyles()(() => ({
    input: {
        width: "13rem",
    },
}))

export function SelectShopType({
    shopTypes,
    setShopTypes,
}: {
    shopTypes: string[]
    setShopTypes: React.Dispatch<React.SetStateAction<string[]>>
}) {
    const { l10n } = useAppLocalization()
    const { classes } = useStyles()

    const handleChange = (event: SelectChangeEvent<typeof shopTypes>) => {
        const {
            target: { value },
        } = event
        setShopTypes(typeof value === "string" ? value.split(",") : value)
    }

    return (
        <FormControl className={classes.input}>
            <LocalizedStrict id="supplier-merchant-sales-table-shop-type-input-label">
                <InputLabel id="multiple-checkbox-shop-type-label">Shop type</InputLabel>
            </LocalizedStrict>
            <Select
                labelId="multiple-checkbox-shop-type-label"
                id="multiple-checkbox-shop-type"
                multiple
                value={shopTypes}
                onChange={handleChange}
                input={<OutlinedInput label="Shop type" />}
                renderValue={(selected) =>
                    selected
                        .map((value) =>
                            l10n.getStringForEnum("supplier-merchant-sales-table-shop-type-item", value, ""),
                        )
                        .join(", ")
                }
                MenuProps={MenuProps}
            >
                {[...iterateStringEnum(ShopType)].map((name) => (
                    <MenuItem key={name} value={name}>
                        <Checkbox checked={shopTypes.indexOf(name) > -1} />
                        <ListItemText
                            primary={l10n.getStringForEnum("supplier-merchant-sales-table-shop-type-item", name, "")}
                        />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

